import React, {useState, useEffect, useRef} from 'react';
import styles from "../../assets/stylesheets/sass/Datepicker.module.scss";
import '../../assets/stylesheets/sass/Calendar.scss'
// import Calendar from 'react-calendar';
import date_icon from "../../assets/icons/date_icon.svg";
import daterange_icon_black from "../../assets/icons/daterange_icon_black.svg";
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { DateRangePicker } from 'react-date-range';
import { addDays, subDays } from "date-fns";
import fr from "date-fns/locale/fr";
import nlBE from "date-fns/locale/nl-BE";
import enGB from "date-fns/locale/en-GB";
import { ReactSession }  from 'react-client-session';

let defaultDate = [
    {
      startDate: null,
      endDate: new Date(""),
      key: "selection",
      color:"rgb(8, 152, 82)",
    }
  ]
export default function DatepickerRange({onPickDate, label, type, icon, onClear=false}){

  const handleSelect = (ranges) =>{
    const { selection } = ranges;
    setDate([selection]);
  }

  useEffect(()=>{
    if(onClear){
      setstartDate(null);
      setendDate(null);
      setDate([
        {
          startDate: null,
          endDate: new Date(""),
          key: "selection",
          color:"rgb(8, 152, 82)",
        }
      ])
      setshowDatepicker(false);
    }
  }, [onClear])

  const [startDate, setstartDate] = useState(null);
  const [endDate, setendDate] = useState(null);
  const [showDatepicker, setshowDatepicker] = useState(false);
  const [date, setDate] = useState([
    {
      startDate: null,
      endDate: new Date(""),
      key: "selection",
      color:"rgb(8, 152, 82)",
    }
  ]);

  const handleClickDone = () => {
    
    if((date[0].startDate && date[0].endDate) || (date[0].startDate !== null && date[0].endDate !== null)){
      let dateStart = (date[0].startDate).toString().substring(4).substring(0, 11);
      let dateEnd = (date[0].endDate).toString().substring(4).substring(0, 11);
      setstartDate(dateStart);
      setendDate(dateEnd);
      onPickDate(date);
    }
    else {
      onPickDate(null);
    }
    setshowDatepicker(false);
  }

  const datepicker_ref = useRef(null);

    useEffect(()=>{
        function handleClickOutside(event) {
        if (datepicker_ref.current && !datepicker_ref.current.contains(event.target)) {
            setshowDatepicker(false);
        }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };

    }, [datepicker_ref])

  return (
    <>  
      <button className={type === "filter" ? styles.datepicker_button_filter : type === "fixeddoc" ? styles.datepicker_button_fixeddoc : styles.datepicker_button} onClick={()=>{setshowDatepicker(!showDatepicker)}}>
      <div className={type === "filter" ? styles.datepicker_button_containerFilter : styles.datepicker_button_container}>
        <img src={icon ? icon : type !== "filter" ? date_icon : daterange_icon_black} alt="icon"/></div>
        {(startDate && endDate) ? startDate + " - " + endDate : label ? label : "Pick a date"}
      </button>
      {showDatepicker && 
      <>
      <div ref={datepicker_ref} className={type !== "filter" ? styles.date_range_container : styles.date_range_container_filter}>
        <DateRangePicker
          startDatePlaceholder={ReactSession.get("language") === "N" ? "Begindatum" : (ReactSession.get("language") === "F" ? "Date de début" : "Start date")}
          endDatePlaceholder={ReactSession.get("language") === "N" ? "Einddatum" : (ReactSession.get("language") === "F" ? "Date de fin" : "End date")}
          locale={ReactSession.get("language") === "N" ? nlBE : (ReactSession.get("language") === "F" ? fr : enGB)}
          onChange={handleSelect}
          showSelectionPreview={true}
          moveRangeOnFirstSelection={false}
          months={1}
          ranges={typeof(date[0]) === "object" ? ((typeof(date[0].startDate) === "object" && typeof(date[0].endDate) === "object") ? date : defaultDate) : defaultDate}
          direction="horizontal"
          staticRanges={[]}
          inputRanges={[]}
          editableDateInputs={true}
        />
        <div className={styles.button_container}>
          <button className={styles.clearButton} onClick={()=>{
            setDate([{startDate: null, endDate: new Date(""), key: "selection", color:"rgb(8, 152, 82)"}]); setstartDate(null); setendDate(null)}}>
            {ReactSession.get("language") === "N" ? "Datum verwijderen" : (ReactSession.get("language") === "F" ? "Effacer la date" : "Clear date")}
          </button>
          <button onClick={()=>{handleClickDone()}} className={styles.doneButton}>{ReactSession.get("language") === "N" ? "Kies datum" : (ReactSession.get("language") === "F" ? "Choisissez la date" : "Choose date")}</button>
        </div>
      </div>
      </>
      }     
    </>
  )
}